import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { GetData, PostData, PutData } from '../../core/controls/helpers/requests';
import { snackbarMessage } from '../../core/actions';
import { getEnvVariable } from '../environmentalList';
import FormHeader from '../../core/modules/form/cformheader';
import { requestApi } from '../../core/modules/form/utilities';
import atComponents from '../../json/common/attachments/attachmentComponents';
import ExtendedAttachment from './attachmentextend_kept';

export const fetchData = (requestType, url, queryParam, body) => {
    const queryStr = queryParam != null ? `${url}?${queryParam}` : `${url}`
    if (requestType == "GET") {
        return GetData(queryStr);
    }
    else if (requestType == "POST") {
        return PostData(queryStr, body);
    }
    else if (requestType == "PUT")
        return PutData(queryStr, body);
}

const addbreadcrumbs = [
    { "link": "Add Attachments", "materialicon": "attach_file", className: 'eps-breadcrumb-item', class: 'text-light' }
]

const editbreadcrumbs = [
    { "link": "Edit Attachments", "materialicon": "attach_file", className: 'eps-breadcrumb-item', class: 'text-light' }
]


class FileAttachments extends Component {
    constructor(props) {
        super(props)
        const { read, update } = props.options.crud
        let saveUrl = '', removeUrl = '';
        console.log("here")
        if (update) {
            const { post } = update
            const { url, routeProps, matchProps } = post
            saveUrl = url
            removeUrl = url
            routeProps.forEach(each => {
                const { value } = each
                saveUrl.replace(`{${value}}`, this.props.match.params[value])
            });
            matchProps.forEach(each => {
                const { value } = each
                saveUrl.replace(`{${value}}`, this.props[value])
            });
        }
        this.state = {
            AttachmentTypeId: this.props.AttachmentTypeId || 0,
            Id: 0,
            attachmentTypedd: [],
            saveUrl: saveUrl || '',
            removeUrl: removeUrl || '',
            parentId: this.props.parentId || this.props.match.params.routeid1 || this.props.customprops,
            uploadedAttachments: [],
            updateAttachment: this.props.options.updateAttachment || false,
            selecttype: '',
            snackbarmessage: '',
            passresults: null,
            editformat: false,
            noteWizard: '',
            attachmentTypeWizard: '',
            wizardView: false,
            docmissing: false,
            typemissing: '',
            urlmissing: false,
            Attachemntresults: null,
            urlhelpertext: null,
            noteshelpertext: '',
            lengthhelpertext: '',
            notesinvalidhelpertext: '',
            edit: this.props.options.updateAttachment ? false : true,
            saveAttachmentDetails: false

        }
        this.componentsArray = { ...atComponents };
        this.url1 = getEnvVariable('Application') + `/api/Attachments/${this.props.match.params.routeid1}/attachment/${this.props.initialloadextrainfo && this.props.initialloadextrainfo.results ? this.props.initialloadextrainfo.results["APPLICATION_STATUS"] : null}`;
        this.url2 = getEnvVariable('Admin') + `/api/AttachmentType/All/Active`;
        this.LayoutForm = React.createRef()
    }

    componentDidMount() {
        this.didmountinitialload();
    }

    didmountinitialload() {
        const { options, components, extraProps, dataItem } = this.props
        const { crud, validations } = options ? options : {}
        const { read } = crud ? crud : {}
        const { get } = read ? read : {}
        const { routeProps, hidepath } = get ? get : {}
        // if (this.props.match.path === '/Administration/applicationreview/:routeid/:routeid1/attachments/view/:routeid2' || this.props.options.ViewWizardAttachment) {
        //     requestApi({ get: { url: getEnvVariable('Application')+`/api/Attachments/${this.props.match.params.routeid1 || this.state.parentId || this.props.customprops}/attachment/${this.props.match.params.routeid2 || dataItem.Id}` } }, this.props.match.params.routeid2, null).then(results => {
        //         this.setState({
        //             passresults: results, wizardView: true,
        //         })
        //     })
        // }

        if (this.props.options.updateAttachment) {
            requestApi({ get: { url: getEnvVariable('Application') + `/api/${getEnvVariable('ModuleKey')}Attachment/${this.props.match.params.routeid1 || this.state.parentId || this.props.customprops}/attachment/${this.props.dataItem.Id}` } }, this.props.dataItem.Id, null).then(results => {
                this.setState({
                    passresults: results, wizardView: true
                })
            })
        }

    }

    handleEdit = () => {
        this.setState({ editformat: true });
    }
    handleBack = () => {
        this.props.onClose();
    }



    componentDidUpdate(prevProps, prevState) {
        if (prevProps.dataItem != this.props.dataItem) {
            this.didmountinitialload();
        }
    }

    handleSave = () => {
        const { options, customprops, formgridadd, WizardAttachment } = this.props;
        const { crud } = options;
        const { read, update } = crud;
        const { passresults } = this.state
        let editorValResults = this.state.Attachemntresults
        let strlength = editorValResults != null ? editorValResults.Notes.length : ""
        if (editorValResults == null) {
            this.setState({ typemissing: 'Attachment Type is required' })
        }
        else if (editorValResults.Notes.trim().length == 0 && editorValResults.Notes && editorValResults.Notes != "") {
            this.setState({ notesinvalidhelpertext: 'Notes is not valid' })
        }
        else if (editorValResults.Notes && editorValResults.Notes != "" && editorValResults.Notes.charAt(0) === " " || editorValResults.Notes.charAt(strlength - 1) === " ") {
            this.setState({ noteshelpertext: ' Leading or trailing spaces are not allowed' })
        }
        else if (editorValResults.Notes && editorValResults.Notes != "" && strlength > 2) {
            this.setState({ lengthhelpertext: ' Notes length should be in the range of (0-4000)' })
        }
        else if (editorValResults && editorValResults.AttachmentType === 'U') {
            this.setState({ saveAttachmentDetails: true })
        }
        else {
            this.handlefinalSave();
        }
    }

    handlefinalSave = (files = []) => {
        let proceed = false;
        const { options, customprops, formgridadd, WizardAttachment } = this.props;
        const { crud } = options;
        const { read, update } = crud;
        const { passresults } = this.state
        let editorValResults = this.state.Attachemntresults;
        editorValResults['AttachmentDetails'] = files || [];
        if (editorValResults['AttachmentType'] === 'P' || (editorValResults['AttachmentType'] === 'U' && files.length > 0))
            proceed = true;
        else proceed = false
        delete editorValResults['AttachmentType']
        if (proceed && editorValResults && editorValResults.AttachmentTypeId && !this.state.urlhelpertext && !this.state.docmissing && !this.state.urlmissing) {
            //editorValResults.AttachmentDetails = editorValResults
            if (editorValResults && this.props.options.updateAttachment) {
                let dfinalresults = { ...passresults, ...editorValResults }
                requestApi({ post: { url: getEnvVariable('Application') + `/api/${getEnvVariable('ModuleKey')}Attachment/${this.state.parentId}/UploadFiles` } }, null, dfinalresults, null, false, "updated successfully")
                    .then(res => {
                        this.setState({ AttachmentTypeId: dfinalresults.AttachmentTypeId, edit: true }, () => {
                            this.props.onClose();
                        })
                    })
            }
            else if (editorValResults) {
                requestApi({ post: { url: getEnvVariable('Application') + `/api/${getEnvVariable('ModuleKey')}Attachment/${this.state.parentId}/UploadFiles` } }, null, editorValResults)
                    .then(res => {
                        this.setState({ AttachmentTypeId: editorValResults.AttachmentTypeId }, () => {
                            this.props.onClose();
                        })
                    })
            }
        }
        // else this.setState({ customSave: true })

    }

    getState = (state) => { // this will trigger always
        let formresults = { Notes: state.results.Notes, AttachmentTypeId: (state.results.AttachmentTypeId) || null, Id: (state.results.Id) }
        this.setState({ finalresults: formresults })
    }


    handleCustomSave = () => {
        this.setState({ customSave: false })
    }

    getallresultsInfo = (attachment) => {
        if (attachment.AttachmentTypeIdVal != "") {
            this.setState({ typemissing: '' })
        }
        if (attachment.Notes.trim().length != 0) {
            this.setState({ notesinvalidhelpertext: '' })
        }
        if (attachment.Notes != "" && attachment.Notes.charAt(0) != " " || attachment.Notes.charAt(attachment.Notes.length - 1) != " ") {
            this.setState({ noteshelpertext: '' })
        }
        if (attachment.Notes != "" && attachment.Notes.length <= 4000) {
            this.setState({ lengthhelpertext: '' })
        }
        else {
            this.setState({ urlhelpertext: null, urlmissing: false, docmissing: false })
        }

        this.setState({ Attachemntresults: attachment })

    }
    //This will save the attachments to AWS and returns full attachment details results here.
    attachmentDetailsCallBack(details) {
        let tempData = [];
        if (Array.isArray(details) && details.length > 0) {
            details.map(el => {
                tempData.push({ FileName: el.fileName, ContentType: el.extension, FileType: el.fileType, FileReference: el.guid, Size: el.size, AttachmentType: 'U', IsFinal: el.IsFinal ? el.IsFinal : 'N' })
            });
        }
        this.handlefinalSave(tempData);
    }
    //returns array of files information that loaded into the page. Not uploaded to the system yet.
    onAttachmentAddCallBack(files) {
        console.log('files added... validate here----------', files)
    }

    render() {
        const { options, compmap, dataItem, WizardAttachment, onFullScreen, onExitFullScreen, fullscreen, exitfullscreen, onNextItemClick, onPrevItemClick } = this.props;
        const { validations, updateAttachment } = options;
        const { customSave } = this.state
        let roleaccess = this.props.accessPermissions && this.props.accessPermissions.moduleDistrictAccess && this.props.accessPermissions.moduleDistrictAccess ? Object.values(this.props.accessPermissions.moduleDistrictAccess).includes('Add') ? 'CanAdd' : Object.values(this.props.accessPermissions.moduleDistrictAccess).includes('Update') ? 'CanEdit' : Object.values(this.props.accessPermissions.moduleDistrictAccess).includes('Read') ? 'CanRead' : 'CanAdd' : 'CanAdd'
        let portal = this.props.accessPermissions ? this.props.accessPermissions.portal : null
        let canAdd = (!roleaccess || !portal) ? true : portal == "I" && roleaccess == "CanAdd" ? true : (portal == "E") ? true : false
        let canEdit = (!roleaccess || !portal) ? true : portal == "I" && roleaccess == "CanEdit" ? true : (portal == "E") ? true : false
        let canRead = (!roleaccess || !portal) ? true : portal == "I" && roleaccess == "CanRead" ? true : (portal == "E") ? true : false
        return (
            <Fragment>
                {!this.props.hideheader && !this.props.WizardAttachment && <FormHeader className="row" savebutton={this.props.options.updateAttachment ? false : (canAdd || canEdit) ? true : false} backbutton={true}
                    handleSave={this.handleSave} breadcrumbs={this.props.options.updateAttachment ? editbreadcrumbs : addbreadcrumbs} handleEdit={this.handleEdit} handleBack={this.handleBack}
                    onFullScreen={onFullScreen} onExitFullScreen={onExitFullScreen} fullscreen={fullscreen} exitfullscreen={exitfullscreen} dataItem={dataItem} navigateup={this.props.options.updateAttachment ? true : false} navigatedown={this.props.options.updateAttachment ? true : false}
                    onNextItemClick={onNextItemClick} onPrevItemClick={onPrevItemClick} />}
                {/* <div className={dataItem || WizardAttachment ? "col-sm-12" : "col-sm-6"}>
                    <CForm {...this.props} customId={this.props.customId} compmap={compmap} components={!this.props.options.updateAttachment ? this.componentsArray.components[0].components : viewapplicationattachments.components[0].components} getState={this.getState} validations={validations}
                        options={options} results={this.state.passresults} customSave={customSave} handleCustomSave={this.handleCustomSave} />
                </div> */}
                <ExtendedAttachment ref={this.LayoutForm} initialloadextrainfo={this.props.initialloadextrainfo} getallresultsInfo={this.getallresultsInfo} classes={dataItem || WizardAttachment ? true : false} AttachmentTypeId={this.state.AttachmentTypeId} accessPermissions={this.props.accessPermissions} atUploadOptions={this.atUploadOptions} passresults={this.state.passresults} updateAttachment={this.props.options.updateAttachment} editformat={this.state.editformat} archiveParentId={this.props.match.params.routeid1}
                    docmissing={this.state.docmissing} urlmissing={this.state.urlmissing} urlhelpertext={this.state.urlhelpertext} typemissing={this.state.typemissing} noteshelpertext={this.state.noteshelpertext}
                    lengthhelpertext={this.state.lengthhelpertext} notesinvalidhelpertext={this.state.notesinvalidhelpertext} handleSave={this.handleSave} handleEdit={this.handleEdit} dataItem={this.props.dataItem}
                    edit={this.state.edit}
                    canSave={this.state.saveAttachmentDetails} handlefinalSave={this.handlefinalSave}
                    attachmentDetailsCallBack={this.attachmentDetailsCallBack}
                    onAttachmentAddCallBack={this.onAttachmentAddCallBack}
                />
            </Fragment>
        )
    }
}
const mapActions = dispatch => {
    return bindActionCreators({ snackbarMessage }, dispatch);
}

FileAttachments = connect(null, mapActions)(FileAttachments)
export default withRouter(FileAttachments)